import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import { Checkbox, CHECKBOX_THEMES } from 'shared/UI/Checkbox'
import isEmpty from 'lodash/isEmpty'

const PrivacyMessageCheckboxArea = (props) => {

  const isRequiredCheckbox = (checkbox) => {
    return !isEmpty(checkbox.label) && checkbox.is_required
  }

  const requiredCount = props.config.checkboxes.filter(isRequiredCheckbox).length
  const [checkboxes, setCheckboxes] = useState(props.config.checkboxes)
  const [checkedCount, setCheckedCount] = useState(0)

  useEffect(() => {
    props.setSendButtonDisabled(checkedCount < requiredCount)
  }, [checkedCount])

  useEffect(() => {
    setCheckedCount(checkboxes.filter((checkbox) => {
      return isRequiredCheckbox(checkbox) && checkbox.value
    }).length)
  }, [checkboxes])

  const handleClick = (checkbox, index) => {
    checkboxes[index].value = !checkbox.value
    setCheckboxes([...checkboxes])
  }

  const renderCheckboxes = () => {
    return checkboxes.map((checkbox, index) => {
      return (
        !isEmpty(checkbox.label) &&
        <Checkbox
          key={index}
          className="privacy-message-checkbox-container"
          theme={CHECKBOX_THEMES.themeColor}
          label={checkbox.label}
          checked={checkbox.value}
          onClick={() => handleClick(checkbox, index)} />
      )
    })
  }

  return(
    <div>
      <div className='checkbox-area-label'>{props.config.label}</div>
      {renderCheckboxes()}
    </div>
  )
}

PrivacyMessageCheckboxArea.propTypes = {
  config: PropTypes.object.isRequired,
  setSendButtonDisabled: PropTypes.func.isRequired
}

export default PrivacyMessageCheckboxArea
